import { inject, Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { UserService } from './user.service';
import { AuthClaims } from '../models/auth-claims';

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  private readonly auth = inject(AuthService);
  private readonly user = inject(UserService);

  async initialize(): Promise<void> {
    const account = this.auth.getActiveAccount();

    if (!account) {
      return;
    }

    const claims = account.idTokenClaims as AuthClaims | undefined;

    const roles = claims?.roles ?? [];
    const name = claims?.name ?? account.name ?? account.username;
    const email = claims?.preferred_username ?? account.username;

    this.user.setRoles(roles);
    this.user.setUser(name, email);

    await this.user.fetchPhoto();
  }
}
